import React from "react";
import { useParams } from "react-router-dom";
import AuthorizationWrapper from "../AuthorizationWrapper";
import Grid from "@material-ui/core/Grid";
import TableContainer from "@material-ui/core/TableContainer";
import Table from "@material-ui/core/Table";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import TableCell from "@material-ui/core/TableCell";
import TableBody from "@material-ui/core/TableBody";
import Button from "@material-ui/core/Button";
import withIntl from "../../utils/withIntl";
import cloudStore from "../../store/CloudStore";
import EditTextField from "../EditArticle/EditTextField";
import EditPriceTextField from "../EditArticle/EditPriceTextField";
import CircularProgress from "@material-ui/core/CircularProgress";
import EditSwitch from "../EditArticle/EditSwitch";
import { updatePostalCodes } from "./PostalCodeApi";
import { TablePagination } from "@material-ui/core";
import AddPostalCodesDialog from "./AddPostalCodeDialog/AddPostalCodesDialog";
import { useDialog } from "../Dialogs/DialogProvider";

export const rowsPerPage = 5;

function PostalCodes(props) {
  const { taMerchantId } = useParams();
  const [openDialog] = useDialog();

  const getPostalCodes = (taMerchantId) => {
    let taMerchant = cloudStore.merchant?.ta_merchants.find((taMerchant) => taMerchant.id === parseInt(taMerchantId));
    if (taMerchant) {
      return taMerchant.ta_postal_codes;
    } else {
      return null;
    }
  };

  const [postalCodes, setPostalCodes] = React.useState(getPostalCodes(taMerchantId));
  const [page, setPage] = React.useState(0);

  const handleChange = (name, value, postalCodeId) => {
    let newPostalCodes = [...postalCodes];
    let postalCodeIndex = newPostalCodes.findIndex((postalCode) => postalCode.id === postalCodeId);
    if (postalCodeIndex >= 0) {
      newPostalCodes[postalCodeIndex][name] = value;
      updatePostalCodes(taMerchantId, newPostalCodes, newPostalCodes).then((newPostalCodes) => {
        setPostalCodes(newPostalCodes);
      });
    }
  };

  if (!postalCodes) {
    return (
      <div align="center">
        <CircularProgress color="primary" />
      </div>
    );
  }

  let numberOfEmptyPostalCodeRows = (rowsPerPage - (postalCodes.length % rowsPerPage)) % 5;
  let emptyPostalCodeRows = [];
  for (let i = 0; i < numberOfEmptyPostalCodeRows; i++) {
    emptyPostalCodeRows.push({ postal_code: false });
  }
  let postalCodeRows = postalCodes.concat(emptyPostalCodeRows);

  return (
    <AuthorizationWrapper
      permission={"takeaway_delivery.postal_codes"}
      child={() => {
        return (
          <Grid item lg={8} md={12} sm={12} xs={12}>
            <div>
              <TableContainer>
                <Table style={{ width: "auto" }} size="small">
                  <TableHead>
                    <TableRow>
                      <TableCell style={{ padding: "5px" }}>
                        {props.intl.formatMessage({ id: "postal_codes" })}
                      </TableCell>
                      <TableCell style={{ padding: "5px" }}>
                        {props.intl.formatMessage({ id: "amount_with_extra" })}
                      </TableCell>
                      <TableCell style={{ padding: "5px" }}>
                        {props.intl.formatMessage({ id: "extra_amount" })}
                      </TableCell>
                      <TableCell style={{ padding: "5px" }}>
                        {props.intl.formatMessage({ id: "minimum_amount" })}
                      </TableCell>
                      <TableCell style={{ padding: "5px" }}>{props.intl.formatMessage({ id: "distance" })}</TableCell>
                      <TableCell style={{ padding: "5px" }}>{props.intl.formatMessage({ id: "active" })}</TableCell>
                      <TableCell style={{ padding: "5px" }} />
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {postalCodeRows
                      .sort((x, y) => {
                        return parseInt(x.postal_code) - parseInt(y.postal_code);
                      })
                      .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                      .map((postalCode) => {
                        if (!postalCode.postal_code) {
                          return (
                            <TableRow>
                              <TableCell style={{ height: "39px" }} />
                              <TableCell style={{ height: "39px" }} />
                              <TableCell style={{ height: "39px" }} />
                              <TableCell style={{ height: "39px" }} />
                              <TableCell style={{ height: "39px" }} />
                            </TableRow>
                          );
                        }
                        return (
                          <TableRow key={postalCode.id}>
                            <TableCell style={{ padding: "0px" }}>
                              <EditTextField
                                key={postalCode.postal_code}
                                authorizationField={"postalCodeManagement.postal_codes"}
                                value={postalCode.postal_code}
                                onBlur={(value) => {
                                  handleChange("postal_code", value, postalCode.id);
                                }}
                              />
                            </TableCell>
                            <TableCell style={{ padding: "0px" }}>
                              <EditPriceTextField
                                key={postalCode.amount_with_extra_costs}
                                authorizationField={"postalCodeManagement"}
                                price={postalCode.amount_with_extra_costs}
                                title={"Vul 0 in om altijd bezorgkosten te rekenen"}
                                onBlur={(value) => {
                                  handleChange("amount_with_extra_costs", value, postalCode.id);
                                }}
                              />
                            </TableCell>
                            <TableCell style={{ padding: "0px" }}>
                              <EditPriceTextField
                                key={postalCode.extra_costs}
                                authorizationField={"postalCodeManagement"}
                                price={postalCode.extra_costs}
                                onBlur={(value) => {
                                  handleChange("extra_costs", value, postalCode.id);
                                }}
                              />
                            </TableCell>
                            <TableCell style={{ padding: "0px" }}>
                              <EditPriceTextField
                                key={postalCode.min_amount}
                                authorizationField={"postalCodeManagement"}
                                price={postalCode.min_amount}
                                onBlur={(value) => {
                                  handleChange("min_amount", value, postalCode.id);
                                }}
                              />
                            </TableCell>
                            <TableCell style={{ padding: "0px" }}>
                              <EditTextField
                                key={postalCode.distance}
                                authorizationField={"postalCodeManagement"}
                                value={postalCode.distance}
                                onBlur={(value) => {
                                  handleChange("distance", value, postalCode.id);
                                }}
                              />
                            </TableCell>
                            <TableCell style={{ padding: "0px" }}>
                              <EditSwitch
                                key={postalCode.active ? 1 : 0}
                                value={postalCode.active}
                                authorizationField={"postalCodeManagement"}
                                onChange={(value) => {
                                  handleChange("active", value, postalCode.id);
                                }}
                              />
                            </TableCell>
                          </TableRow>
                        );
                      })}
                  </TableBody>
                </Table>
              </TableContainer>
              <TablePagination
                component="div"
                count={postalCodes.filter((row) => row.postal_code).length}
                rowsPerPage={rowsPerPage}
                page={page}
                onChangePage={(event, newPage) => {
                  setPage(newPage);
                }}
                labelRowsPerPage=""
                rowsPerPageOptions={[rowsPerPage]}
              />
              <AuthorizationWrapper
                permission={"takeaway_delivery.add_postal_codes"}
                child={
                  <Button
                    onClick={() => {
                      openDialog({
                        children: (
                          <AddPostalCodesDialog
                            addNewPostalCode={(newPostalCodes) => {
                              let postalCodesObject = {};
                              postalCodes.forEach((postalCode) => {
                                postalCodesObject[postalCode.id] = postalCode;
                              });
                              newPostalCodes.forEach((postalCode) => {
                                postalCodesObject[postalCode.id] = postalCode;
                              });

                              setPostalCodes(Object.keys(postalCodesObject).map((id) => postalCodesObject[id]));
                            }}
                            taMerchantId={taMerchantId}
                            rowsPerPage={rowsPerPage}
                            postalCodes={postalCodes}
                          />
                        ),
                      });
                    }}
                  >
                    {props.intl.formatMessage({ id: "add_postal_codes" })}
                  </Button>
                }
              />
            </div>
          </Grid>
        );
      }}
    />
  );
}

export default withIntl(PostalCodes);
